import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import { OrderReceiptResponse } from '@models/order';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import ReceiptDivider from '../ReceiptDivider';

interface Props {
    receipt: OrderReceiptResponse;
}

function CashReceipts({ receipt }:Props) {
    const { t } = useTranslation('orderReceipt');
    const { cashReceipts } = receipt;
    if (cashReceipts.length === 0) {
        return null;
    }
    return (
        <Column fullWidth spacing={0.5}>
            <Text size='headline' fontWeight='bold'>{t('cashReceipts.title')}</Text>
            {cashReceipts.map((it, idx) => {
                const {
                    type, issueNumber, approvalAmount, approvalNo, numbers,
                } = it;
                const displayNumber = numbers.join(', ');
                return (
                    <Fragment key={idx.toString()}>
                        <Row fullWidth justify='space-between'>
                            <Text>{t(`cashReceipts.type.${type}`)}</Text>
                            <Text>{displayNumber}</Text>
                        </Row>
                        <Row fullWidth justify='space-between'>
                            <Text>{t('cashReceipts.approvalNumber')}</Text>
                            <Text>{approvalNo}</Text>
                        </Row>
                        <Row fullWidth justify='space-between'>
                            <Text>{t('cashReceipts.approvalAmount')}</Text>
                            <Text>{approvalAmount?.toLocaleString()}</Text>
                        </Row>
                        <Row fullWidth justify='space-between'>
                            <Text>{t('cashReceipts.issueNumber')}</Text>
                            <Text>{issueNumber}</Text>
                        </Row>
                    </Fragment>
                );
            })}
            <ReceiptDivider/>
        </Column>
    );
}

export default CashReceipts;
